<template>
	<div class="pagination fixed">
		<div class="pagination__body">
			<div class="pagination__show">
				<p>{{ textPerPage }}</p>
				<div class="dropdown-wrapper">
					<DropdownSimple 
						:options="[3, 5, 10, 15, 20, 30]"
						v-model="perPage"
						@input="onPerPage"
					/>
				</div>
			</div>
			<div class="pagination__list-wrapper">
				<a @click="paginationPrev" class="pagination__btn prev" :class="{ disabled: !canPrev }">
					<inline-svg :src="require(`@/assets/img/Arrow-prev.svg`)"/>
					<span>{{ $translate('prev') }}</span>
				</a>
				<ul class="pagination__list" v-if="dots">
					<li style="margin-right: 10px;">
						<input type="text" class="pagination_input" :value="current+1" @change="paginationInputChange">
					</li>
					<template v-for="(p, index) in pages">
						<li :key="index" v-if="index <= current+2 && index >= current-2">
							<a @click="setCurrent(index)" :class="{ active: isCurrent(index) }">{{ p }}</a>
						</li>
					</template>
				</ul>
				<ul class="pagination__list" v-else>
					<li v-for="(p, index) in pages" :key="index">
						<a @click="setCurrent(index)" :class="{ active: isCurrent(index) }">{{ p }}</a>
					</li>
				</ul>
				<a @click="paginationNext" class="pagination__btn next" :class="{ disabled: !canNext }">
					<span>{{ $translate('next') }}</span>
					<inline-svg :src="require(`@/assets/img/Arrow-next.svg`)"/>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import DropdownSimple from '@/components/base/DropdownSimple.vue';
export default {
	name: 'Pagination',
	components: {
		DropdownSimple
	},
	props: {
		items: {
			type: Array,
			default: () => []
		},
		value: {
			type: Array,
			default: () => []
		},
		textPerPage: {
			type: String,
			default: () => 'Rows per page:'
		},
		dots: {
			type: Boolean,
			dafault: () => false,
		}
	},

	watch: {
		items(val) {
			this.paginate();
		},
		value(val){
			this.paginate();
		}
	},

	data() {
		return {
			perPage: 10,
			current: 0
		}
	},

	computed: {
		pages() {
			let result = Math.ceil(this.items.length / this.perPage)
			return result > 0 ? result : 1
		},
		paginated() {
			const res = [];
			for (let i = 0; i < this.pages; i++) {
				const start = i * this.perPage;
				const end = start + this.perPage;
				const page = this.items.slice(start, end);
				res.push(page);
			}
			return res;
		},
		isCurrent() {
			return i => i === this.current
		},
		canPrev() {
			return this.current > 0
		},
		canNext() {
			return this.current < (this.pages - 1)
		},
	},

	methods: {
		paginationPrev() {
			if(this.canPrev) this.current--
			this.paginate();
		},
		paginationNext() {
			if(this.canNext) this.current++
			this.paginate();
		},
		setCurrent(i) {
			this.current = i;
			this.paginate();
		},
		onPerPage() {
			this.current = 0;
			this.$nextTick(this.paginate);
		},

		paginate() {
			this.$emit('input', this.paginated[this.current]);
		},

		paginationInputChange(event){
			let value = +event.target.value - 1;
			if(value >= 0 && value < this.pages){
				this.setCurrent(value);
			} else if(value >= 0 && value > this.pages){
				this.setCurrent(this.pages-1);
			} else {
				this.setCurrent(this.current);
			}

			console.log('paginationInputChange:', value);
		}
	},
	mounted(){
		this.paginate();
	}
}
</script>

<style>
.pagination_input {
	width: 38px;
    border: 1px solid #e0e0e0;
    padding: 7px 5px;
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    border-radius: var(--border-radius-7);
    color: var(--text-primary);
}
</style>